import { Typography } from "antd"

function SalesOperationComponent() {
    return (
        <>
            <Typography.Title level={4} > Sales & Operations </Typography.Title>
            <div
                style={{
                    margin: "auto",
                    width: "60%",
                }}
            >
                <iframe src="/Sales and Operations - Version 03.pdf" width="900" height="700"></iframe>
            </div>
        </>

    )
}
export default SalesOperationComponent